import { browser } from '$app/environment'


const existGoogleAutoCompleteKey =
	(String(import.meta.env.VITE_PUBLIC_GOOGLE_AUTO_COMPLETE_API_KEY) || '') !== ''

const environment = {
	// development, staging, production
	name:
		String(import.meta.env.VITE_PUBLIC_NODE_ENV) === 'undefined'
			? 'dev'
			: String(import.meta.env.VITE_PUBLIC_NODE_ENV),
	isProduction: String(import.meta.env.VITE_PUBLIC_NODE_ENV) === 'production',
	isStaging: String(import.meta.env.VITE_PUBLIC_NODE_ENV) === 'staging',
	isDev: String(import.meta.env.VITE_PUBLIC_NODE_ENV) === 'dev',
	apiUrl: String(
		browser
			? import.meta.env.VITE_PUBLIC_CLIENT_API_URL
			: import.meta.env.VITE_PUBLIC_SERVER_API_URL
	),
	siteUrl: String(
		browser
			? import.meta.env.VITE_PUBLIC_CLIENT_SITE_URL
			: import.meta.env.VITE_PUBLIC_SERVER_SITE_URL
	),
	allowIndexing: import.meta.env.VITE_PUBLIC_ALLOW_INDEXING,
	cookiePrefix: String(import.meta.env.VITE_PUBLIC_COOKIE_PREFIX),
	gtmApiKey: String(import.meta.env.VITE_PUBLIC_GOOGLE_TM_KEY),
	goptApiKey: String(import.meta.env.VITE_PUBLIC_GOOGLE_OPT_KEY),
	googleApiKey: String(import.meta.env.VITE_PUBLIC_GOOGLE_API_KEY),
	googleOneTapKey: String(import.meta.env.VITE_PUBLIC_GOOGLE_ONE_TAP_KEY),
	googleAutoCompeteApiKey: String(
		existGoogleAutoCompleteKey
			? import.meta.env.VITE_PUBLIC_GOOGLE_AUTO_COMPLETE_API_KEY
			: import.meta.env.VITE_PUBLIC_GOOGLE_API_KEY
	),
	sentryEnvironment: String(import.meta.env.VITE_PUBLIC_SENTRY_ENVIRONMENT),
	stripeProdTbl: String(import.meta.env.VITE_PUBLIC_STRIPE_PRCTBL),
	stripeApiKey: String(import.meta.env.VITE_PUBLIC_STRIPE_API_KEY),
	// copyrightYear: String(import.meta.env.VITE_PUBLIC_COPYRIGHT_YEAR),
	copyrightYear: String(new Date().getFullYear()),
	sentryDsn: String(import.meta.env.VITE_PUBLIC_SENTRY_DSN),
	sentryEnv: String(import.meta.env.VITE_PUBLIC_SENTRY_ENV),
	processEnvSet: false,
	healthyPageOn: true,
	openAiApiKey: String(import.meta.env.VITE_PUBLIC_OPENAI_API_KEY),
	openAiAssistantId: String(import.meta.env.VITE_PUBLIC_OPENAI_ASSISTANT_ID),

	setProcessEnv(pEnv: any){
		if (environment.processEnvSet) return

		let apiPort = ''
		let appPort = ''

		if(browser){
			apiPort = (pEnv.client_api_port!='')?pEnv.client_api_port:''
			appPort = (pEnv.client_app_port!='')?pEnv.client_app_port:''
		}
		else {
			apiPort = (pEnv.server_api_port!='')?pEnv.server_api_port:''
			appPort = (pEnv.server_app_port!='')?pEnv.server_app_port:''
		}

		environment.apiUrl = environment.apiUrl.replace('8081', apiPort)
		environment.siteUrl = environment.siteUrl.replace('8080', appPort)

		// const apiUrl = environment.apiUrl + apiPort
		// const siteUrl = environment.siteUrl + appPort

		// environment.apiUrl = String(apiUrl)
		// environment.siteUrl = String(siteUrl)
		environment.processEnvSet = true
	
		// if (!browser) console.log({ environment })
	}
}

export default environment
